import { Box, Typography } from "@mui/material";

// Deliberately not a warning, and deliberately not silent. An account that was
// already closed at the bank before Plaid stopped listing it has no data left
// to give, so there is no gap and nothing to reconnect -- but the account does
// visibly disappear from the list above, and a customer who notices that
// deserves an explanation rather than being left to wonder.
const closedAccountsText = (count, lastActivityLabel, institutionName) => {
  const subject =
    count > 1 ? `${count} accounts are` : "An account is";
  const verb = count > 1 ? "They had" : "It had";
  const activity = lastActivityLabel
    ? ` ${verb} already stopped sending transactions before then (most recent activity ${lastActivityLabel}).`
    : ` ${verb} never sent us any transactions.`;

  return `${subject} no longer listed by ${institutionName}.${activity} That usually means the account was closed, so nothing is missing from your footprint and there is nothing you need to do. Everything already imported from ${count > 1 ? "them" : "it"} still counts.`;
};

const ClosedAccountsNote = ({ note, institutionName }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="body2" color="text.secondary">
      {closedAccountsText(note.count, note.lastActivityLabel, institutionName)}
    </Typography>
  </Box>
);

export default ClosedAccountsNote;
